import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
import './styles/element-variables.scss'
import "@/styles/index.scss"; // global css
import _ from "lodash";
import App from "./App";
import router from "./router";
import store from "./store";
import { signData, Loading } from "@/utils/sign-cfg";
import Astrict from "@/utils/astrict";

// import "@/icons"; // icon
import "@/assets/icons"; // icon
import "@/permission"; // permission control
import "./utils/date-utils.js";
import permission from "@/directive/permission/index.js"; // 权限判断指令
import { funcMap, checkFuncMap } from "@/utils/function";

import i18n from "./i18n/i18n";
Vue.use(ElementUI);
Vue.use(permission);
Vue.use(Astrict);

Vue.prototype.signData = signData;
Vue.prototype.Loading = Loading;
Vue.prototype.funcMap = funcMap;
Vue.prototype.checkFuncMap = checkFuncMap;
Vue.prototype.msgSuccess = function(msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
};

Vue.prototype.msgError = function(msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
};
Vue.config.productionTip = false;

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js